import {Action} from "@ngrx/store";
import { IUser} from "../../models/security/user-profile.interface";
import {IParty} from "@retail-data-factory/rdf-angular-types-api";

export enum EAuthenticatedUserActions {
  LoadAuthenticatedUser = '[Authenticated User] Load User Information',
  LoadAuthenticatedUserSuccess = '[Authenticated User] Loading User Information Success',
  LoadAuthenticatedUserFailure = '[Authenticated User] Loading User Information Failure',
  LoadSelectedPartyProfile = '[Authenticated User] Load Selected Party Information',
  LoadSelectedPartyProfileSuccess = '[Authenticated User] Load Selected Party Information Success',
  LoadSelectedPartyProfileFailure = '[Authenticated User] Load Selected Party Information Failure',

  SetUserEmail = '[Authenticated User] Set User Email'
}

export class LoadAuthenticatedUser implements Action {
  public readonly type = EAuthenticatedUserActions.LoadAuthenticatedUser;
}
export class LoadAuthenticatedUserSuccess implements Action {
  public readonly type = EAuthenticatedUserActions.LoadAuthenticatedUserSuccess;
  constructor ( public payload: IUser){}
}
export class LoadAuthenticatedUserFailure implements Action {
  public readonly type = EAuthenticatedUserActions.LoadAuthenticatedUserFailure;
}

export class LoadSelectedPartyProfile implements Action {
  public readonly type = EAuthenticatedUserActions.LoadSelectedPartyProfile;
}
export class LoadSelectedPartyProfileSuccess implements Action {
  public readonly type = EAuthenticatedUserActions.LoadSelectedPartyProfileSuccess;
  constructor ( public payload: IParty){}
}
export class LoadSelectedPartyProfileFailure implements Action {
  public readonly type = EAuthenticatedUserActions.LoadSelectedPartyProfileFailure;
}

export class SetUserEmail implements Action {
  public readonly type = EAuthenticatedUserActions.SetUserEmail;
  constructor ( public payload: string){}

}


export type AuthenticatedUserActions =
  LoadAuthenticatedUser |
  LoadAuthenticatedUserSuccess |
  LoadAuthenticatedUserFailure |
  LoadSelectedPartyProfile |
  LoadSelectedPartyProfileSuccess |
  LoadSelectedPartyProfileFailure |
  SetUserEmail;
